import { Chart, registerables } from "chart.js"
import {
  formatNumber,
  axisLabelPlugin,
  customTickOffsetPlugin,
  verticalLinePlugin,
} from "./plugin"

export default function initInvestmentReturnChart() {
  // Register chart controllers etc.
  Chart.register(...registerables)

  document.addEventListener("ajaxSnippetUpdate", generateChart)

  generateChart()
}

function generateChart() {
  const chart = document.querySelector(".investment-return-chart-chart")

  if (!chart) return

  const { colorAverage, colorExpected } = chart.dataset

  const years = chart.dataset.years.split(",")
  const valuesExpected = chart.dataset.valuesExpected.split(",").map(Number)
  const valuesAverage = chart.dataset.valuesAverage.split(",").map(Number)

  const config = {
    type: "line",
    data: {
      labels: years,
      datasets: [
        {
          label: "Average",
          data: valuesAverage,
          borderColor: colorAverage,
          backgroundColor: `${colorAverage}1a`,
          fill: "stack",
          tension: 0.3,
          pointBackgroundColor: colorAverage,
          pointRadius: valuesAverage.map((_, i, arr) =>
            i === arr.length - 1 ? 4 : 0
          ),
          pointHoverRadius: 6,
          borderWidth: 2,
          order: 2, // Draw first (bottom layer)
        },
        {
          label: "Expected",
          data: valuesExpected,
          borderColor: colorExpected,
          backgroundColor: `${colorExpected}1a`,
          fill: "stack", // Fill to previous dataset (Average)
          tension: 0.3,
          pointBackgroundColor: colorExpected,
          pointRadius: valuesExpected.map((_, i, arr) =>
            i === arr.length - 1 ? 4 : 0
          ),
          pointHoverRadius: 6,
          borderWidth: 2,
          order: 1, // Draw second (top layer)
        },
      ],
    },
    plugins: [verticalLinePlugin, axisLabelPlugin, customTickOffsetPlugin],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        x: {
          type: "category",
          beginAtZero: true,
          grid: {
            display: true,
            drawTicks: true,
            drawOnChartArea: false,
            tickLength: 10,
          },
          ticks: {
            display: false,
          },
          border: {
            display: false,
          },
        },
        y: {
          position: "right",
          font: "Gotham, sans-serif",
          grid: {
            display: true,
            drawTicks: false,
            color: "#CAD7DC",
            lineWidth: 1,
          },
          ticks: {
            color: "#666",
            font: {
              family: "Gotham, sans-serif",
              size: 14,
              weight: "bold",
            },
            callback: function (value) {
              return formatNumber(chart, value)
            },
            maxTicksLimit: 10,
            padding: 10,
          },
          border: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          titleColor: "#36383A",
          titleFont: {
            family: "Gotham, sans-serif",
            size: 14,
          },
          titleMarginBottom: 8,
          bodyColor: "#000",
          bodyFont: {
            family: "Gotham, sans-serif",
            size: 19,
            lineHeight: 1.38,
          },
          borderColor: "#A6A8AB",
          borderWidth: 1,
          cornerRadius: 10,
          padding: {
            top: 13,
            bottom: 13,
            left: 16,
            right: 16,
          },
          boxWidth: 12,
          boxHeight: 12,
          boxPadding: 8,
          caretSize: 0,
          caretPadding: 16,
          displayColors: true,
          usePointStyle: true,
          callbacks: {
            title: function (context) {
              const yearNumber = parseInt(context[0].label)
              const yearDate = new Date()
              yearDate.setFullYear(yearDate.getFullYear() + yearNumber)
              return yearDate.getFullYear()
            },
            label: function (context) {
              return `${formatNumber(
                chart,
                context.parsed.y,
                false,
                false,
                true
              )}`
            },
          },
        },
        filler: {
          propagate: false,
        },
      },
      elements: {
        line: {
          tension: 0.3,
        },
      },
    },
  }

  new Chart(chart.getContext("2d"), config)
}
